import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import { AmountLimitComponent } from "./component";

export const AmountLimit = compose(protectedComponentHoc)(AmountLimitComponent);
